
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/our-studies",
      function () {
        return require("private-next-pages/our-studies/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/our-studies"])
      });
    }
  